//#region libraries
import React from "react"
//moment
import moment from 'moment';
//redux
import { useSelector, useDispatch } from "react-redux";
import { selectPaxQuestions, postSurveyAnswers, resetAddSurveyAnswersStatus, selectFlightDetails } from "_redux/slices/analytics/review-control-panel";

//custom component
import SurveyRunner from "_components/organisms/feedback/survey-runner";
import SurveyCompleted from "./survey-conclusion";
//#endregion

// Airport (CAA / QR-code) survey adapter. Builds booking details from the flight
// details the passenger typed in, then hands the shared SurveyRunner the questions
// and an onSubmit that persists answers. Completion reuses the survey-conclusion screen.
const SurveyQuestions = ({ iata }) => {

    //#region redux
    const dispatch = useDispatch();
    const flightDetails = useSelector(selectFlightDetails)
    const paxSurveyQustions = useSelector(selectPaxQuestions);
    //#endregion

    //#region build + persist answers
    function processName(p) {
        let regexCAPS = /(?<!^)(CHD|\CHD.|MSTR|MR|MS|MRS|MR\.|MS\.|MRS\.)\s+/;
        p = p.replace(regexCAPS, " ");
        p = p.toLowerCase();
        let regex = /^(chd|\chd.|mr|ms|mrs|mr\.|ms\.|mrs\.)\s+/;
        p = p.replace(regex, "");
        p = p.replace(/\s/g, "_");
        return p;
    }

    const getLocalID = () => `${flightDetails.flightNumber}${flightDetails.departureDate}--${processName(flightDetails.paxName)}`;

    const getBookingDetails = () => ({
        bookingId: getLocalID(),
        passengerName: flightDetails.paxName,
        departureDate: flightDetails.departureDate,
        flightNumber: flightDetails.flightNumber,
    })

    const handleSubmit = async (answers) => {
        const surveyAnswer = {
            iata,
            surveyTitle: paxSurveyQustions.groupTitle,
            surveyId: paxSurveyQustions._id,
            createdAt: moment(new Date()).format().split("T")[0],
            taskDetails: {
                taskId: "email-survey",
                employeeId: "email",
            },
            bookingDetails: getBookingDetails(),
            answers,
            language: "en",
            completed: true
        }
        await dispatch(postSurveyAnswers(surveyAnswer)).unwrap();
        dispatch(resetAddSurveyAnswersStatus());
    }
    //#endregion

    return (
        <SurveyRunner
            questions={paxSurveyQustions?.questions || []}
            language={"en"}
            onSubmit={handleSubmit}
            renderCompleted={() => <SurveyCompleted />}
        />
    )
}

export default SurveyQuestions
